var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mask"},[_c('div',[_c('img',{attrs:{"src":require("../assets/404.png")}}),_c('p',[_vm._v(" "+_vm._s(_vm.$t("pageNotFound"))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }